/* eslint-disable */

import * as THREE from 'three'
import ImageShader from './Shaders/Image.js'

class Sections
{
    /**
     * Constructor
     */
    constructor(options)
    {
        // Options
        this.time = options.time
        this.content = options.content

        // Set up
        this.scrollPos = 0
        this.width = 800
        this.height = 600
        this.sectionHeight = 600
        this.skew = 10

        // Scene
        this.scene = new THREE.Scene()

        // Camera
        this.camera = new THREE.OrthographicCamera(800 / - 2, 800 / 2, 600 / 2, 600 / - 2, 0.001, 10000)
        this.camera.position.y = 1000
        this.camera.lookAt(new THREE.Vector3())
        this.scene.add(this.camera)

        this.setBackgrounds()
        // this.setLogos()
    }

    /**
     * Set backgrounds
     */
    setBackgrounds()
    {
        // Set up
        this.backgrounds = {}
        this.backgrounds.config = []
        this.backgrounds.config.push({
            blending: null,
            path: require('../sections/bg-globe.jpg'),
            alphaPath: require('../sections/bg-globe-alpha.jpg')
        })

        for(const _content of this.content)
        {
            this.backgrounds.config.push({
                blending: null,
                path: _content.image
                // path: '/static/home/bg-csgo.jpg'
            })
        }

        this.backgrounds.config.push({
            blending: null,
            path: require('../sections/bg-sponsors.jpg')
        })

        this.backgrounds.items = []

        this.backgrounds.container = new THREE.Object3D()
        this.scene.add(this.backgrounds.container)

        // Each section
        for(let i = 0; i < this.backgrounds.config.length; i++)
        {
            const _backgroundConfig = this.backgrounds.config[i]
            const background = {}
            background.index = i

            background.ready = false
            background.image = new Image()
            background.image.crossOrigin = 'anonymous'
            background.image.addEventListener('load', () =>
            {
                background.geometry = new THREE.PlaneGeometry(background.image.width, background.image.height, 1, 1)
                background.texture = new THREE.Texture(background.image)
                background.texture.needsUpdate = true
                // background.material = new THREE.MeshBasicMaterial({ map: background.texture, side: THREE.DoubleSide })

                const uniforms = {
                    image: { type: 't', value: background.texture },
                    scale: { type: 'vec2', value: new THREE.Vector2(1, 1) },
                    offset: { type: 'vec2', value: new THREE.Vector2(0, 0) },
                    alpha: { type: 'f', value: 1 },
                    hasAlphaImage: { type: 'f', value: 0 }
                }

                if(_backgroundConfig.alphaPath)
                {
                    uniforms.alphaImage = { type: 't', value: new THREE.TextureLoader().load(_backgroundConfig.alphaPath) }
                    uniforms.hasAlphaImage = { type: 'f', value: 1 }
                }

                background.material = new THREE.ShaderMaterial({
                    uniforms: uniforms,
                    vertexShader: ImageShader.vertexShader,
                    fragmentShader: ImageShader.fragmentShader
                })
                if(_backgroundConfig.blending)
                {
                    background.material.blending = _backgroundConfig.blending
                }
                background.material.transparent = true

                background.mesh = new THREE.Mesh(background.geometry, background.material)
                background.mesh.rotation.y = Math.PI
                background.mesh.rotation.x = Math.PI * 0.5
                background.mesh.position.y = background.index * 2

                this.backgrounds.container.add(background.mesh)

                background.ready = true

                this.backgrounds.items.push(background)

                this.resize(this.width, this.height)
            })
            background.image.src = _backgroundConfig.path
        }
    }

    /**
     * Resize
     */
    resize(screenWidth, screenHeight)
    {
        this.width = screenWidth
        this.height = screenHeight

        const halfWidth = screenWidth * 0.5
        const halfHeight = screenHeight * 0.5

        const screenRatio = screenWidth / screenHeight
        const verticeSkewOffset = halfWidth * Math.tan(Math.PI * 0.02)
        this.sectionHeight = this.height + verticeSkewOffset * 2

        const halfSectionHeight = this.sectionHeight * 0.5

        // Camera
        this.camera.left = halfWidth
        this.camera.right = - halfWidth
        this.camera.top = - halfHeight
        this.camera.bottom = halfHeight

        this.camera.updateProjectionMatrix()

        // Each background
        for(let i = 0; i < this.backgrounds.items.length; i++)
        {
            const _background = this.backgrounds.items[i]

            // Is ready
            if(_background.ready)
            {
                const imageWidth = _background.image.width
                const imageHeight = _background.image.height
                const imageRatio = imageWidth / imageHeight

                // Update geometry verticies
                // Top left
                _background.mesh.geometry.vertices[0].x = - halfWidth
                _background.mesh.geometry.vertices[0].y = halfSectionHeight - verticeSkewOffset

                // Top right
                _background.mesh.geometry.vertices[1].x = halfWidth
                _background.mesh.geometry.vertices[1].y = halfSectionHeight + verticeSkewOffset

                // Bottom left
                _background.mesh.geometry.vertices[2].x = - halfWidth
                _background.mesh.geometry.vertices[2].y = - halfSectionHeight - verticeSkewOffset

                // Bottom right
                _background.mesh.geometry.vertices[3].x = halfWidth
                _background.mesh.geometry.vertices[3].y = - halfSectionHeight + verticeSkewOffset

                _background.mesh.geometry.verticesNeedUpdate = true

                // Update material
                if(imageRatio < screenRatio)
                {
                    _background.material.uniforms.scale.value.x = 1
                    _background.material.uniforms.scale.value.y = imageRatio / screenRatio
                }
                else
                {
                    _background.material.uniforms.scale.value.x = screenRatio / imageRatio
                    _background.material.uniforms.scale.value.y = 1
                }

                // Position
                _background.mesh.position.z = - _background.index * this.sectionHeight
            }
        }
    }

    /**
     * Update
     */
    update()
    {
        // Each section
        for(let i = 0; i < this.backgrounds.items.length; i++)
        {
            const _background = this.backgrounds.items[i]

            // Is ready
            if(_background.ready)
            {
                // Parallax
                const parallaxValue = (this.scrollPos - _background.index) * 0.15
                _background.material.uniforms.offset.value.y = parallaxValue
            }
        }

        // Each logo
        /*for(let i = 0; i < this.logos.items.length; i++)
        {
            const _logo = this.logos.items[i]

            // Is ready
            if(_logo.ready)
            {
                // Test if logo should be active
                const distance = Math.abs(this.scrollPos - _logo.index)

                if(distance < 0.5)
                {
                    // Fade in
                    _logo.material.uniforms.alpha.value += 0.002 * this.time.delta
                }
                else
                {
                    // Fade out
                    _logo.material.uniforms.alpha.value -= 0.004 * this.time.delta
                }

                // Clamp
                if(_logo.material.uniforms.alpha.value < - 0.75)
                {
                    _logo.material.uniforms.alpha.value = -0.75
                }
                else if(_logo.material.uniforms.alpha.value > 1)
                {
                    _logo.material.uniforms.alpha.value = 1
                }
            }
        }*/

        this.backgrounds.container.position.z = this.sectionHeight * this.scrollPos
    }
}

export default Sections



// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/Sections.js